// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2o3_3","actionsCol":"EnrolledClinics_actionsCol__3Gxav"};